import { message } from "antd";
import Button from "Components/Button";
import Input from "Components/Input";
import { useChangePassword } from "hooks/ChangePassword/useChangePassword";
import DashboardLayout from "Layout/DashboardLayout";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const initialState = { oldPassword: "", password: "" };

const ChangePassword = () => {
  const [payload, setPayload] = useState(initialState);

  const { mutate, isPending } = useChangePassword();
  const navigate = useNavigate();

  const submitForm = () => {
    mutate(payload, {
      onSuccess: () => {
        setPayload(initialState);
        navigate("/");
        localStorage.clear();
        message.success("Proceed to Login with new password");
      },
    });
  };

  return (
    <DashboardLayout title="Change Password" back={true}>
      <div className="w-[450px] mx-auto">
        <h3 className="text-center text-black text-[20px] font-semibold pt-[50px]">
          Change Password
        </h3>
        <p className="text-center text-[#828282] mb-[30px]">
          Kindly enter and setup a new password for your account
        </p>
        <div>
          <Input
            label={"Old Password"}
            name={"password"}
            type={"password"}
            disabled={isPending}
            value={payload?.oldPassword}
            placeholder={"Enter Old Password"}
            onChange={(e) =>
              setPayload({ ...payload, oldPassword: e?.target?.value })
            }
          />
          <Input
            label={"New Password"}
            name={"password"}
            type={"password"}
            disabled={isPending}
            value={payload?.password}
            placeholder={"Enter New Password"}
            onChange={(e) =>
              setPayload({ ...payload, password: e?.target?.value })
            }
          />
          {/* <p>{JSON.stringify(payload)}</p> */}
          <Button
            onClick={submitForm}
            disabled={!payload?.password || !payload?.oldPassword}
            isLoading={isPending}
            label={"Change"}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ChangePassword;
